function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _readOnlyError(name) { throw new TypeError("\"" + name + "\" is read-only"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import './relation.scss';
import CustomHTMLElement from 'html-element';
import Popover from 'popover';
import SpriteSvg from '../svg';

var RelationInput = /*#__PURE__*/function (_CustomHTMLElement) {
  _inherits(RelationInput, _CustomHTMLElement);

  var _super = _createSuper(RelationInput);

  function RelationInput() {
    _classCallCheck(this, RelationInput);

    return _super.apply(this, arguments);
  }

  _createClass(RelationInput, [{
    key: "_runSetup",
    value: function _runSetup() {
      var _this = this;

      _get(_getPrototypeOf(RelationInput.prototype), "_runSetup", this).call(this);

      this.button = this.querySelector('a.button');
      this.button.addEventListener('click', function (_event) {
        return _this.buttonClicked(_this.button);
      });
      this.name = this.getAttribute('name');
      this.multiple = this.getBooleanAttribute('multiple');
    } ////////// Relation

  }, {
    key: "relationElements",
    get: function get() {
      return this.querySelectorAll('relation-input-relation');
    }
  }, {
    key: "addRelation",
    value: function addRelation(injectable, id, content) {
      if (!this.multiple) {
        var currentRelations = this.relationElements;
        currentRelations.forEach(function (r) {
          return r.remove();
        });
      }

      var relationElement = new RelationInputRelation(injectable, id, content, this);
      this.append(relationElement);
    } ////////// Events

  }, {
    key: "showInjectionPopover",
    value: function showInjectionPopover(injectable) {
      var _this2 = this;

      var popover = new Popover({
        removeOnHide: true
      });
      popover.addEventListener('popover:display', function () {
        popover.querySelectorAll('[data-inject-id]').forEach(function (button) {
          button.addEventListener('click', function (_event) {
            var id = button.getAttribute('data-inject-id');
            var content = button.getAttribute('data-inject-title');

            _this2.addRelation(injectable, id, content);

            popover.hide();
          });
        });
      }); // TODO hardcoded url

      var path = injectable.path;

      if (!path.startsWith('/')) {
        path = "/".concat(path);
      }

      if (!path.endsWith('inject')) {
        path = path.replace(/\/?$/, '/inject');
      } // Get Ids of already selected items


      var ids = [];

      try {
        Array.from(document.querySelectorAll("input[name=\"".concat(this.querySelector('input').name, "\"]"))).map(function (i) {
          if (i.value) ids.push(i.value);
        });
      } catch (err) {
        '', _readOnlyError("ids");
      }

      popover.loadContent("".concat(path, "?input_id=").concat(this.id).concat(ids && ids.length > 0 ? "&selected_ids=".concat(ids) : ''));
      popover.show();
    }
  }, {
    key: "buttonClicked",
    value: function buttonClicked(button) {
      var injectableType = button.getAttribute('data-injectable-type');
      var injectablePath = button.getAttribute('data-injectable-path');
      var injectable = {
        type: injectableType,
        path: injectablePath
      };
      this.showInjectionPopover(injectable);
    }
  }]);

  return RelationInput;
}(CustomHTMLElement);

var RelationInputRelation = /*#__PURE__*/function (_CustomHTMLElement2) {
  _inherits(RelationInputRelation, _CustomHTMLElement2);

  var _super2 = _createSuper(RelationInputRelation);

  function RelationInputRelation() {
    _classCallCheck(this, RelationInputRelation);

    return _super2.apply(this, arguments);
  }

  _createClass(RelationInputRelation, [{
    key: "_runSetup",
    value: function _runSetup(injectable, id, content, input) {
      _get(_getPrototypeOf(RelationInputRelation.prototype), "_runSetup", this).call(this);

      if (injectable) {
        var spanElement = document.createElement('span');
        spanElement.innerHTML = content;
        this.appendChild(spanElement);
        var hiddenElement = document.createElement('input');
        hiddenElement.type = 'hidden';

        if (input.multiple) {
          hiddenElement.name = "".concat(input.name, "[]");
        } else {
          hiddenElement.name = input.name;
        }

        hiddenElement.value = id;
        this.appendChild(hiddenElement);
        this.createButton();
      } else {
        this.hiddenField = this.querySelector('input[type=hidden]');
        this.createButton();
      }
    }
  }, {
    key: "createButton",
    value: function createButton() {
      var _this3 = this;

      this.iconElement = new SpriteSvg();
      this.iconElement.iconName = 'icon_cross';
      var buttonElement = document.createElement('a');
      buttonElement.classList.add('relation-input-relation__button');
      buttonElement.appendChild(this.iconElement);
      buttonElement.addEventListener('click', function (_event) {
        return _this3.buttonClicked();
      });
      this.appendChild(buttonElement);
    } ////////// Add/Remove

  }, {
    key: "buttonClicked",
    value: function buttonClicked() {
      this.remove();
    }
  }]);

  return RelationInputRelation;
}(CustomHTMLElement);

window.customElements.define('relation-input', RelationInput);
window.customElements.define('relation-input-relation', RelationInputRelation);